import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthHeaderService } from '../views/authheader.service';

@Injectable({
  providedIn: 'root'
})
export class BudgetServiceService {
  budgeturl: string;
  options = new RequestOptions({
    headers: this._headerService.getHeader(),
  });
  constructor(private http: Http, private _headerService: AuthHeaderService){
      this.budgeturl = environment.budgeturl;
  }
  SendForm = (budget: any)=> {
      return this.http.post(this.budgeturl, budget, this.options).pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }

  EditBudget = (budget: any,id)=> {
    return this.http.put(this.budgeturl+"/"+id, budget, this.options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
}
DeleteBudget = (id)=> {
  return this.http.delete(this.budgeturl+"/"+id, this.options).pipe(
    map((response) => response.json()),
    catchError((error: Response) => {
      return observableThrowError(error);
    })
  );
  this.getAllBudget();
}


  getAllBudget(){
    return this.http.get(this.budgeturl, this.options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


}
function observableThrowError(error: Response): any {
  throw new Error('Function not implemented.');
}

